export default function PartnersSection() {
  const audiences = [
    {
      icon: "ri-user-heart-line",
      title: "Consumidores Finais",
      description:
        "Indivíduos e famílias que buscam comprar o primeiro imóvel, financiar uma casa maior ou obter crédito para realizar projetos de vida.",
      cta: "Quero Comprar Meu Imóvel",
    },
    {
      icon: "ri-home-office-line",
      title: "Corretores de Imóveis",
      description:
        "Parceiros que desejam oferecer as melhores condições de financiamento para seus clientes, aumentando conversão e fidelização.",
      cta: "Seja um Parceiro",
    },
    {
      icon: "ri-building-2-line",
      title: "Imobiliárias",
      description:
        "Empresas que buscam uma parceria estratégica para agilizar vendas e oferecer soluções financeiras completas aos compradores.",
      cta: "Parceria Corporativa",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
            Público-Alvo
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Para Quem Atuamos
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Nossas soluções são pensadas para atender diferentes perfis,
            desde consumidores finais até parceiros comerciais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {audiences.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 rounded-2xl p-8 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:shadow-lg text-center"
            >
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-6 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                {item.description}
              </p>
              <a
                href="https://wa.me/5511985860949"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                {item.cta}
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}